import(/* webpackMode: "eager" */ "/vercel/path0/apps/main-app/src/app/auth/layout.tsx");
